import { render } from "./lab_details.vue?vue&type=template&id=ab4a4e6e&scoped=true"
import script from "./lab_details.vue?vue&type=script&lang=js"
export * from "./lab_details.vue?vue&type=script&lang=js"

import "./lab_details.vue?vue&type=style&index=0&id=ab4a4e6e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4a4e6e"]])

export default __exports__